var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expand-row"},[_c('span',{staticStyle:{"padding-bottom":"4px"}},[_vm._v("该分类下还有：")]),_vm._v(" "),_c('Table',{ref:"list",attrs:{"max-height":400,"columns":_vm.columns1,"data":_vm.row}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45176244","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/review/table-expand.vue
// module id = null
// module chunks = 